import { Popover, PopoverInteractionKind, PopoverPosition } from '@blueprintjs/core'
import React from 'react'

interface Props {
  width?: string
  extraIconStyle?: React.CSSProperties
  popoverPosition?: PopoverPosition
  children: React.ReactNode
}

// We usually pass in
//   <p className="no-margin-bottom">
// with manually inserted <br/> tags to keep the width reasonable.
const Help: React.FC<Props> = ({ children, extraIconStyle, width = null, popoverPosition = PopoverPosition.AUTO }) => {
  const iconStyle = React.useMemo(
    () => ({
      // React.memo helps avoid extra re-renders (multiple calls to spread these styles together would not create the same JS object)
      ...{ color: '#5c7080', cursor: 'pointer' },
      ...extraIconStyle
    }),
    [extraIconStyle]
  )

  const popoverStyle = React.useMemo(() => ({ width }), [width])

  return (
    <Popover
      className="help-popover"
      interactionKind={PopoverInteractionKind.HOVER}
      content={
        <div className="popover-content" style={popoverStyle}>
          {children}
        </div>
      }
      position={popoverPosition}
      target={<span tabIndex={-1} className="bp3-icon-standard bp3-icon-help" style={iconStyle} />}
    />
  )
}

// workaround for Jest https://github.com/airbnb/enzyme/issues/1875
export { Help }
export default React.memo(Help)
